module.exports = __webpack_public_path__ + "img/s5.c7e6b62a.png";